// Langue du storefront : sert a servir les libelles panier en anglais sur /en (US/UK).
var NF_LANG = (document.documentElement.getAttribute('lang') || 'fr').toLowerCase().slice(0, 2);
var NF_EN = NF_LANG === 'en';
/* Choisit la chaine selon la langue de la page ; retombe sur le francais si la langue est inconnue. */
function NF_T(fr, en, es, it, nb, pl) {
  if (NF_LANG === 'nb' && nb) return nb;
  if (NF_LANG === 'pl' && pl) return pl;
  if (NF_LANG === 'en') return en;
  if (NF_LANG === 'es') return es;
  if (NF_LANG === 'it') return it;
  return fr;
}
/* ============================================================
   NYROFIT — JPRO CLONE INTERACTIONS V1
   Scroll-triggered fade-up + before/after slider
   ============================================================ */

(function () {
  'use strict';

  /* ---------- 1. SCROLL FADE-UP via IntersectionObserver ---------- */
  function initScrollFadeUp() {
    // Bail if user prefers reduced motion (accessibility)
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.jpro-fade-up').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // Old browser fallback — show everything
      document.querySelectorAll('.jpro-fade-up').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // animate once, free the watcher
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
    );

    // Auto-target most JPRO section headings/cards
    var targets = document.querySelectorAll(
      '.jpro-fade-up, ' +
        '.jpro-features__item, ' +
        '.jpro-accessories__item, ' +
        '.jpro-bundle__card, ' +
        '.jpro-reviews__card, ' +
        '.jpro-comparison__row, ' +
        '.jpro-commitment__stat, ' +
        '.jpro-features__heading, ' +
        '.jpro-bundle__heading, ' +
        '.jpro-comparison__heading, ' +
        '.jpro-faq__heading'
    );

    targets.forEach(function (el, i) {
      el.classList.add('jpro-fade-up');
      // Stagger children of the same group (max 6 to keep snappy)
      el.style.transitionDelay = Math.min(i % 6, 5) * 80 + 'ms';
      observer.observe(el);
    });
  }

  /* ---------- 2. BEFORE/AFTER DRAGGABLE SLIDER ---------- */
  function initBeforeAfterSlider() {
    var containers = document.querySelectorAll('.jpro-storytelling__beforeafter');
    if (!containers.length) return;

    containers.forEach(function (container) {
      // If already enhanced, skip
      if (container.classList.contains('jpro-ba-ready')) return;

      var halves = container.querySelectorAll('.jpro-storytelling__half');
      if (halves.length !== 2) return;

      // Wrap into slider structure
      container.classList.add('jpro-ba-ready');
      var beforeEl = halves[0];
      var afterEl = halves[1];

      beforeEl.classList.add('jpro-ba-before');
      afterEl.classList.add('jpro-ba-after');

      // Build divider handle
      var handle = document.createElement('div');
      handle.className = 'jpro-ba-handle';
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-label', 'Comparer avant et après');
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');
      handle.setAttribute('aria-valuenow', '50');
      handle.innerHTML = '<span class="jpro-ba-handle__icon">⇆</span>';
      container.appendChild(handle);

      // Initial position 50%
      var setPosition = function (pct) {
        pct = Math.max(0, Math.min(100, pct));
        afterEl.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
        handle.setAttribute('aria-valuenow', Math.round(pct));
      };
      setPosition(50);

      var dragging = false;

      var onMove = function (clientX) {
        var rect = container.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        setPosition(pct);
      };

      // Mouse events
      handle.addEventListener('mousedown', function (e) {
        dragging = true;
        e.preventDefault();
      });
      container.addEventListener('mousedown', function (e) {
        // Click anywhere on container to jump
        onMove(e.clientX);
        dragging = true;
      });
      window.addEventListener('mousemove', function (e) {
        if (dragging) onMove(e.clientX);
      });
      window.addEventListener('mouseup', function () { dragging = false; });

      // Touch events
      handle.addEventListener('touchstart', function (e) {
        dragging = true;
      }, { passive: true });
      container.addEventListener('touchmove', function (e) {
        if (dragging && e.touches[0]) onMove(e.touches[0].clientX);
      }, { passive: true });
      window.addEventListener('touchend', function () { dragging = false; });

      // Keyboard accessibility
      handle.setAttribute('tabindex', '0');
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(handle.style.left) || 50;
        if (e.key === 'ArrowLeft') setPosition(current - 5);
        if (e.key === 'ArrowRight') setPosition(current + 5);
        if (e.key === 'Home') setPosition(0);
        if (e.key === 'End') setPosition(100);
      });
    });
  }

  /* ---------- 3. BUNDLE RADIO SYNC (visual feedback) ---------- */
  function initBundleSync() {
    var radios = document.querySelectorAll('.jpro-bundle__radio');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Force CSS :has() repaint reliably on all browsers
        var group = document.getElementsByName(radio.name);
        Array.prototype.forEach.call(group, function (r) {
          var card = r.closest('.jpro-bundle__card');
          if (card) card.classList.toggle('is-selected', r.checked);
        });
      });
      // Sync initial state
      if (radio.checked) {
        var card = radio.closest('.jpro-bundle__card');
        if (card) card.classList.add('is-selected');
      }
    });
  }

  /* ---------- 4. URGENCY TIMER (countdown HH:MM:SS) ---------- */
  function initUrgencyTimer() {
    var timers = document.querySelectorAll('.jpro-bb-timer');
    if (!timers.length) return;

    timers.forEach(function (timer) {
      if (timer.dataset.timerInit) return;
      timer.dataset.timerInit = '1';

      var hoursTarget = parseInt(timer.dataset.timerHours || '3', 10);
      var totalSeconds = hoursTarget * 3600;

      // Persist per-session via sessionStorage so refresh doesn't reset
      var storageKey = 'jproTimerExpiry';
      var expiry = parseInt(sessionStorage.getItem(storageKey) || '0', 10);
      var now = Date.now();
      if (!expiry || expiry < now) {
        expiry = now + totalSeconds * 1000;
        sessionStorage.setItem(storageKey, String(expiry));
      }

      var hEl = timer.querySelector('[data-timer-h]');
      var mEl = timer.querySelector('[data-timer-m]');
      var sEl = timer.querySelector('[data-timer-s]');
      if (!hEl || !mEl || !sEl) return;

      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      var tick = function () {
        var diff = Math.max(0, expiry - Date.now());
        var s = Math.floor(diff / 1000);
        var h = Math.floor(s / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        hEl.textContent = pad(h);
        mEl.textContent = pad(m);
        sEl.textContent = pad(sec);

        if (diff <= 0) {
          // Reset timer with fresh duration (perpetual urgency)
          expiry = Date.now() + totalSeconds * 1000;
          sessionStorage.setItem(storageKey, String(expiry));
        }
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- 5. STICKY ADD-TO-CART (sur scroll) ---------- */
  function initStickyAtc() {
    var mainAtc = document.querySelector('.product-form__buttons .product-form__submit');
    if (!mainAtc) return;

    // Build the sticky bar once
    var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1');
    var priceEl = document.querySelector('.price__regular .price-item--regular, .price-item--regular');
    var priceCompareEl = document.querySelector('.price__sale .price-item--sale, .price-item--sale');
    var mediaImg = document.querySelector('.product__media-item img, .product-media img');

    var bar = document.createElement('div');
    bar.className = 'jpro-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Barre de commande rapide');

    var imgSrc = mediaImg ? (mediaImg.currentSrc || mediaImg.src) : '';
    var title = titleEl ? titleEl.textContent.trim() : 'Ajouter au panier';
    var priceHtml = priceEl ? priceEl.outerHTML : '';

    bar.innerHTML =
      (imgSrc ? '<img class="jpro-sticky-atc__img" src="' + imgSrc + '" alt="" loading="lazy">' : '') +
      '<div class="jpro-sticky-atc__info">' +
        '<div class="jpro-sticky-atc__title">' + title + '</div>' +
        '<div class="jpro-sticky-atc__price">' + priceHtml + '</div>' +
      '</div>' +
      '<button type="button" class="jpro-sticky-atc__btn">Ajouter au panier</button>';

    document.body.appendChild(bar);

    var btn = bar.querySelector('.jpro-sticky-atc__btn');
    btn.addEventListener('click', function () {
      // Click the real ATC button to trigger native Shopify submit
      mainAtc.click();
    });

    // Show bar when main ATC leaves viewport
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else {
            bar.classList.add('is-visible');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -50px 0px' }
    );
    observer.observe(mainAtc);
  }

  /* ---------- 5b. CART RESERVATION TIMER (barre noire, compte à rebours) ---------- */
  function initCartTimer() {
    var DURATION = 15 * 60 * 1000; // 15 minutes
    var CLOCK_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2"/><path d="M9 2h6"/></svg>';
    if (!window.__nfCartTimerEnd) { window.__nfCartTimerEnd = Date.now() + DURATION; }

    var fmt = function (ms) {
      if (ms < 0) ms = 0;
      var s = Math.floor(ms / 1000), m = Math.floor(s / 60), ss = s % 60;
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    };
    // Signal TOUJOURS frais (pas de cache) : présence d'articles dans le DOM du drawer.
    var hasItems = function () {
      return !!document.querySelector('cart-drawer .cart-item, #CartDrawer .cart-item');
    };
    var ensureBar = function () {
      var show = hasItems();
      document.querySelectorAll('cart-drawer, #CartDrawer').forEach(function (target) {
        var existing = target.querySelector('.jpro-cart-timer');
        if (!show) { if (existing) existing.remove(); return; }
        if (existing) return;
        var bar = document.createElement('div');
        bar.className = 'jpro-cart-timer';
        var NF_CLK = '<strong class="jpro-cart-timer__clock">--:--</strong>';
        bar.innerHTML = CLOCK_SVG + '<span>' + NF_T(
          'Votre panier est réservé pendant ' + NF_CLK + ' !',
          'Your cart is reserved for ' + NF_CLK + '!',
          'Tu carrito está reservado durante ' + NF_CLK + '.',
          'Il tuo carrello è riservato per ' + NF_CLK + '.',
          'Handlekurven din er reservert i ' + NF_CLK + '.',
          'Twój koszyk jest zarezerwowany na ' + NF_CLK + '!') + '</span>';
        var header = target.querySelector('.drawer__header');
        if (header && header.nextSibling) {
          header.parentNode.insertBefore(bar, header.nextSibling);
        } else if (header) {
          header.parentNode.appendChild(bar);
        } else {
          target.insertBefore(bar, target.firstChild);
        }
      });
    };
    var tick = function () {
      ensureBar();
      var rem = window.__nfCartTimerEnd - Date.now();
      if (rem <= 0) { window.__nfCartTimerEnd = Date.now() + DURATION; rem = DURATION; }
      var txt = fmt(rem);
      document.querySelectorAll('.jpro-cart-timer__clock').forEach(function (el) { el.textContent = txt; });
    };
    if (window.__nfCartTimerInt) clearInterval(window.__nfCartTimerInt);
    window.__nfCartTimerInt = setInterval(tick, 1000);
    tick();
    document.addEventListener('cart:updated', tick);
  }

  /* ---------- 6. CART PROGRESS BAR + FREE GIFT AUTO-ADD ---------- */
  function initCartProgress() {
    // Config — édite ici pour adapter
    var THRESHOLD = 50; // 50€ pour livraison gratuite
    // ----- CADEAU OFFERT (free gift with purchase) -----
    // Si le produit DÉCLENCHEUR est dans le panier → on ajoute automatiquement 1× le produit CADEAU.
    // Le cadeau est rendu 0€ par la remise auto Shopify "Lunettes Bluetooth achetée = NyroVision offerte"
    // (BXGY -100%). Sans cette remise, le cadeau serait FACTURÉ : les deux vont ensemble.
    var GIFT_TRIGGER_PRODUCT_ID = window.jproGiftTriggerProductId || 15756560204160; // Vision Pro Bluetooth
    var GIFT_VARIANT_ID         = window.jproFreeGiftVariantId    || 58314772447616; // Lunettes Velocity (SKU cadeau dédié 0€, masqué du site)
    var FREE_GIFT_PROPERTY_KEY  = '_free_gift';

    // Livraison TOUJOURS offerte (marketing) — barre pleine + badge camion au bout droit.
    // Plus de seuil 50€ : le bandeau est statique et célébratif.
    var renderBar = function (cartTotal) {
      var truck = '<svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M3 6.5h10.3v8.4H3z"/>' +
        '<path d="M13.3 9.4h3.4l2.6 2.6v2.9h-6z"/>' +
        '<circle cx="6.7" cy="16.8" r="1.7"/>' +
        '<circle cx="16.4" cy="16.8" r="1.7"/>' +
      '</svg>';
      return '<div class="jpro-cart-progress jpro-cart-progress--drawer jpro-cart-progress--always" data-success="1">' +
        '<p class="jpro-cart-progress__msg">' + NF_T(
          'Félicitations, vous avez la <strong>livraison offerte</strong>',
          'Congratulations, you have <strong>free shipping</strong>',
          'Enhorabuena, tienes <strong>envío gratuito</strong>',
          'Congratulazioni, hai la <strong>spedizione gratuita</strong>',
          'Gratulerer, du har <strong>gratis frakt</strong>',
          'Gratulacje, masz <strong>darmową dostawę</strong>') + '</p>' +
        '<div class="jpro-cart-progress__track">' +
          '<div class="jpro-cart-progress__bar"><div class="jpro-cart-progress__fill"></div></div>' +
          '<div class="jpro-cart-progress__badge">' +
            '<span class="jpro-cart-progress__badge-ic" aria-hidden="true">' + truck + '</span>' +
            '<span class="jpro-cart-progress__badge-lb">' + NF_T('Livraison<br>offerte', 'Free<br>shipping', 'Envío<br>gratuito', 'Spedizione<br>gratuita', 'Gratis<br>frakt', 'Darmowa<br>dostawa') + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    };

    // Tag visuel "FREE" sur les items gratuits dans le drawer
    var tagFreeItems = function () {
      document.querySelectorAll('.cart-drawer .cart-item').forEach(function (item) {
        var priceEl = item.querySelector('.cart-item__final-price, .product-option');
        if (!priceEl) return;
        var txt = (priceEl.textContent || '').replace(/\s/g, '');
        var isFree = /(^|\D)0[.,]0{2}/.test(txt) || /(^|\D)0[.,]?00€/.test(txt) || txt.indexOf('€0,00') >= 0 || txt.indexOf('€0.00') >= 0;
        if (isFree && !item.querySelector('.jpro-cart-free-tag')) {
          var tag = document.createElement('span');
          tag.className = 'jpro-cart-free-tag';
          tag.textContent = 'CADEAU';
          var details = item.querySelector('.cart-item__details');
          if (details) details.appendChild(tag);
        }
      });
    };

    // Garde anti-récursion : nos propres requêtes panier ne doivent pas redéclencher la synchro.
    var giftSyncing = false;

    // ⚡ PERF : les 3 synchros cadeaux (Velocity, semelles, patchs) tiraient CHACUNE son
    // /cart.js au chargement, en cascade → jusqu'à 7 requêtes panier sur une seule page.
    // Ici : une seule requête partagée pendant 1,5 s, invalidée dès qu'on modifie le panier.
    var cartCache = null, cartCacheAt = 0;
    function getCart(){
      if (cartCache && (Date.now() - cartCacheAt) < 1500) return Promise.resolve(cartCache);
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartCache = c; cartCacheAt = Date.now(); return c; });
    }
    function invalidateCart(){ cartCache = null; cartCacheAt = 0; }

    // Rafraîchit le drawer + la pastille panier à partir des sections renvoyées par Shopify
    var applyCartSections = function (data) {
      if (data && data.sections) {
        try {
          var parser = new DOMParser();
          if (data.sections['cart-drawer']) {
            var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
            var fresh = doc.querySelector('cart-drawer');
            var cur = document.querySelector('cart-drawer');
            if (cur) cur.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
          }
          if (data.sections['cart-icon-bubble']) {
            var bub = document.getElementById('cart-icon-bubble');
            if (bub) bub.innerHTML = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html').body.innerHTML;
          }
        } catch (e) {}
      }
      inject();
      tagFreeItems();
    };

    // Cœur : 1 SEUL cadeau gratuit si le déclencheur est présent ; sinon aucun.
    // - déclencheur présent + 0 cadeau   → ajoute 1
    // - déclencheur présent + trop (>1)  → ramène à 1 exemplaire (anti "3 paires à 0€")
    // - pas de déclencheur + cadeau(x)   → retire tout (bloque aussi l'ajout direct via l'URL du produit 0€)
    var postCart = function (endpoint, body, common) {
      giftSyncing = true;
      invalidateCart(); // le panier change → le cache partagé n'est plus valable
      body.sections = common.sections; body.sections_url = common.sections_url;
      return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); }).then(applyCartSections)
        .then(function () { giftSyncing = false; }, function () { giftSyncing = false; });
    };
    var syncFreeGift = function () {
      if (giftSyncing || !GIFT_VARIANT_ID || !GIFT_TRIGGER_PRODUCT_ID) return Promise.resolve();
      return getCart()
        .then(function (cart) {
          // Panier vide → rien à offrir, rien à purger. Évite une écriture /cart/update.js
          // inutile au chargement (elle relançait ensuite toute la cascade de synchros).
          if (!cart.items || !cart.items.length) return Promise.resolve();
          var hasTrigger = cart.items.some(function (it) { return it.product_id == GIFT_TRIGGER_PRODUCT_ID; });
          // Velocity est un SKU cadeau dédié (jamais vendu seul) → on gère TOUTES ses lignes :
          // plafond 1 si Bluetooth présent, retrait total sinon (ferme l'ajout direct via l'URL produit).
          var giftLines = cart.items.filter(function (it) { return it.variant_id == GIFT_VARIANT_ID; });
          giftLines.sort(function (a, b) {
            var pa = a.properties && a.properties[FREE_GIFT_PROPERTY_KEY] ? 1 : 0;
            var pb = b.properties && b.properties[FREE_GIFT_PROPERTY_KEY] ? 1 : 0;
            return pb - pa;
          });
          var totalQty = giftLines.reduce(function (s, it) { return s + it.quantity; }, 0);
          var common = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };

          if (hasTrigger && giftLines.length === 0) {
            var props = {}; props[FREE_GIFT_PROPERTY_KEY] = 'true';
            return postCart('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] }, common);
          }
          if (hasTrigger && (totalQty > 1 || giftLines.length > 1)) {
            var updates = {};
            giftLines.forEach(function (it, idx) { updates[it.key] = idx === 0 ? 1 : 0; }); // garde 1 exemplaire, zéro le reste
            return postCart('/cart/update.js', { updates: updates }, common);
          }
          if (!hasTrigger && giftLines.length) {
            var updates2 = {};
            giftLines.forEach(function (it) { updates2[it.key] = 0; });
            return postCart('/cart/update.js', { updates: updates2 }, common);
          }
          return Promise.resolve();
        }).catch(function () { giftSyncing = false; });
    };

    // ----- CADEAU PATCHS CHAUFFANTS (pages NyroTape genou / hallux) -----
    // SKU cadeau dédié à 0 € (jamais vendu seul : le produit VENDABLE est un autre produit,
    // handle nyrofit-patchs-chauffants). On gère donc TOUTES ses lignes.
    // - aucun NyroTape au panier → on retire tout (ferme l'ajout gratuit via l'URL du produit 0 €)
    // - le cadeau est UNE BOÎTE de N patchs → 1 article par NyroTape, jamais N.
    //   (Sinon la commande affiche "x5" et le préparateur expédie 5 boîtes.)
    //   Le nombre de patchs vit dans la propriété de ligne "Contenu", pas dans la quantité.
    var PATCH_GIFT_VARIANT_ID = window.nfPatchGiftVariantId || 58536213447040;
    var PATCH_TRIGGER_PRODUCT_IDS = window.nfPatchTriggerProductIds || [15849285747072, 15850923884928]; // NyroTape Genou, NyroTape Hallux
    var PATCH_MAX_PER_TRIGGER = 1;

    var syncPatchGift = function () {
      if (giftSyncing || !PATCH_GIFT_VARIANT_ID) return Promise.resolve();
      return getCart()
        .then(function (cart) {
          // Panier vide → rien à offrir, rien à purger. Évite une écriture /cart/update.js
          // inutile au chargement (elle relançait ensuite toute la cascade de synchros).
          if (!cart.items || !cart.items.length) return Promise.resolve();
          var giftLines = cart.items.filter(function (it) { return it.variant_id == PATCH_GIFT_VARIANT_ID; });
          if (!giftLines.length) return Promise.resolve();

          var allowed = 0;
          cart.items.forEach(function (it) {
            if (PATCH_TRIGGER_PRODUCT_IDS.indexOf(it.product_id) !== -1) allowed += PATCH_MAX_PER_TRIGGER * it.quantity;
          });

          var totalQty = giftLines.reduce(function (s, it) { return s + it.quantity; }, 0);
          if (totalQty <= allowed) return Promise.resolve();

          var common = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
          var updates = {};
          var left = allowed;
          giftLines.forEach(function (it) {
            var keep = Math.min(it.quantity, left);
            left -= keep;
            updates[it.key] = keep; // 0 quand allowed === 0 → ligne retirée
          });
          return postCart('/cart/update.js', { updates: updates }, common);
        }).catch(function () { giftSyncing = false; });
    };

    // Cadeau OREILLER des packs NyroCamp : le pack ×2 en offre 2, le pack ×4 en offre 4,
    // soit 1 oreiller offert par matelas commandé. Même contrat que les patchs :
    // - plafond = nombre de matelas au panier → impossible d'en obtenir plus
    // - aucun matelas au panier → on retire tout (ferme l'ajout gratuit via l'URL du produit 0 €)
    var CAMP_GIFT_VARIANT_ID    = window.nfCampGiftVariantId    || 58610433589632; // Oreiller « Offert avec un pack », 0 €
    var CAMP_TRIGGER_PRODUCT_ID = window.nfCampTriggerProductId || 15871921619328; // NyroCamp Matelas de Sol PRO
    var CAMP_MAX_PER_TRIGGER    = 1;

    var syncCampGift = function () {
      if (giftSyncing || !CAMP_GIFT_VARIANT_ID) return Promise.resolve();
      return getCart()
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return Promise.resolve();
          var giftLines = cart.items.filter(function (it) { return it.variant_id == CAMP_GIFT_VARIANT_ID; });
          if (!giftLines.length) return Promise.resolve();

          var allowed = 0;
          cart.items.forEach(function (it) {
            if (it.product_id == CAMP_TRIGGER_PRODUCT_ID) allowed += CAMP_MAX_PER_TRIGGER * it.quantity;
          });

          var totalQty = giftLines.reduce(function (s, it) { return s + it.quantity; }, 0);
          if (totalQty <= allowed) return Promise.resolve();

          var common = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
          var updates = {};
          var left = allowed;
          giftLines.forEach(function (it) {
            var keep = Math.min(it.quantity, left);
            left -= keep;
            updates[it.key] = keep; // 0 quand allowed === 0 → ligne retirée
          });
          return postCart('/cart/update.js', { updates: updates }, common);
        }).catch(function () { giftSyncing = false; });
    };

    // Cadeaux des packs SEMELLES (talonnettes ≥2 paires, rouleau ≥3 paires) :
    // même contrat que Velocity — plafond 1, ajout si palier atteint, retrait total sinon
    // (bloque la commande à 0€ quand le client supprime les semelles du panier).
    var SEM_TRIGGER_PRODUCT_ID = 15816679817600;
    var SEM_GIFTS = [
      { variantId: 58382463369600, minQty: 2 } // Talonnettes de décharge — Cadeau (packs 2 & 3)
    ];
    var SEM_RETIRED_GIFTS = [58382477230464]; // rouleau retiré du bundle → toujours purger s'il traîne au panier
    var syncSemellesGifts = function () {
      if (giftSyncing) return Promise.resolve();
      return getCart()
        .then(function (cart) {
          // Panier vide → rien à offrir, rien à purger. Évite une écriture /cart/update.js
          // inutile au chargement (elle relançait ensuite toute la cascade de synchros).
          if (!cart.items || !cart.items.length) return Promise.resolve();
          var semQty = cart.items.reduce(function (s, it) { return s + (it.product_id == SEM_TRIGGER_PRODUCT_ID ? it.quantity : 0); }, 0);
          var updates = {}, toAdd = [], dirty = false;
          // purge des cadeaux retirés du bundle (ex. rouleau) s'ils traînent encore au panier
          cart.items.forEach(function (it) { if (SEM_RETIRED_GIFTS.indexOf(it.variant_id) > -1) { updates[it.key] = 0; dirty = true; } });
          SEM_GIFTS.forEach(function (g) {
            var target = semQty >= g.minQty ? 1 : 0;
            var lines = cart.items.filter(function (it) { return it.variant_id == g.variantId; });
            var total = lines.reduce(function (s, it) { return s + it.quantity; }, 0);
            if (total === target && lines.length <= 1) return;
            if (target === 1 && lines.length === 0) {
              var props = {}; props[FREE_GIFT_PROPERTY_KEY] = 'semelles'; props['Cadeau'] = '🎁 Offert';
              toAdd.push({ id: g.variantId, quantity: 1, properties: props });
              return;
            }
            lines.forEach(function (it, idx) { updates[it.key] = idx === 0 ? target : 0; });
            dirty = true;
          });
          var common = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
          if (dirty) return postCart('/cart/update.js', { updates: updates }, common).then(function () {
            if (toAdd.length) return postCart('/cart/add.js', { items: toAdd }, common);
          });
          if (toAdd.length) return postCart('/cart/add.js', { items: toAdd }, common);
          return Promise.resolve();
        }).catch(function () { giftSyncing = false; });
    };

    // Injection SYNCHRONE (zéro fetch = instantané), gatée sur la présence réelle d'articles dans le DOM.
    var inject = function () {
      var hasItem = !!document.querySelector('cart-drawer .cart-item, #CartDrawer .cart-item');
      var targets = document.querySelectorAll('cart-drawer, .drawer__inner, #CartDrawer');
      targets.forEach(function (target) {
        var existing = target.querySelector('.jpro-cart-progress');
        if (!hasItem) { if (existing) existing.remove(); return; }
        if (existing) return; // barre statique déjà en place
        var wrapper = document.createElement('div');
        wrapper.innerHTML = renderBar(0);
        var anchor = target.querySelector('.jpro-cart-timer') || target.querySelector('.drawer__header');
        if (anchor && anchor.nextSibling) {
          anchor.parentNode.insertBefore(wrapper.firstChild, anchor.nextSibling);
        } else if (anchor) {
          anchor.parentNode.appendChild(wrapper.firstChild);
        } else {
          target.insertBefore(wrapper.firstChild, target.firstChild);
        }
      });
      tagFreeItems();
    };

    inject();
    document.addEventListener('cart:updated', inject);
    document.addEventListener('cart-drawer:open', inject);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(inject).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      new MutationObserver(tagFreeItems).observe(drawer, { childList: true, subtree: true });
    }

    // ----- Câblage du CADEAU OFFERT -----
    // 1) Au chargement (si le déclencheur est déjà au panier)
    syncFreeGift();
    setTimeout(syncSemellesGifts, 400);
    setTimeout(syncPatchGift, 600);
    setTimeout(syncCampGift, 800);
    // 2) Après chaque modif du panier faite par le thème (ATC, +/-, suppression) — on intercepte fetch
    if (!window.__jproGiftHook) {
      window.__jproGiftHook = true;
      var _fetch = window.fetch;
      window.fetch = function () {
        var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
        var ret = _fetch.apply(this, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url) && !giftSyncing) {
          ret.then(function () { setTimeout(syncFreeGift, 80); setTimeout(syncSemellesGifts, 400); setTimeout(syncPatchGift, 600); setTimeout(syncCampGift, 800); }).catch(function () {});
        }
        return ret;
      };
    }
    // 3) À l'ouverture du drawer (filet de sécurité)
    document.addEventListener('cart-drawer:open', function () { if (!giftSyncing) { syncFreeGift(); setTimeout(syncSemellesGifts, 400); setTimeout(syncPatchGift, 600); } });
  }

  /* ---------- 7. AUTO-PLAY DEFERRED VIDEO MEDIA (Dawn product gallery) ---------- */
  function initAutoplayVideo() {
    // Dawn wraps product videos in <deferred-media> which only renders
    // the actual <video> tag after the user clicks the poster button.
    // We auto-click the poster so the video appears + autoplays on load.
    var deferredEls = document.querySelectorAll('deferred-media');
    if (!deferredEls.length) return;

    var triggerLoad = function (el) {
      if (el.dataset.jproAutoLoaded) return;
      // Only auto-load if it contains a <video> in its template
      var template = el.querySelector('template');
      if (!template || !template.content) return;
      var hasVideo = template.content.querySelector('video, iframe');
      if (!hasVideo) return;

      el.dataset.jproAutoLoaded = '1';

      // Try the native loadContent method first (Dawn custom element API)
      if (typeof el.loadContent === 'function') {
        el.loadContent(false); // false = don't focus the video
      } else {
        // Fallback: click the poster button
        var poster = el.querySelector('.deferred-media__poster');
        if (poster) poster.click();
      }

      // Once the video is in DOM, force play (browser may have paused
      // due to focus/visibility heuristics)
      setTimeout(function () {
        var video = el.querySelector('video');
        if (video) {
          video.muted = true;
          video.setAttribute('playsinline', '');
          video.play().catch(function () {
            // Autoplay blocked — that's OK, browser will respect user policy
          });
        }
      }, 100);
    };

    // Run on visible deferred-media (use IntersectionObserver for lazy)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            triggerLoad(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      deferredEls.forEach(function (el) { io.observe(el); });
    } else {
      deferredEls.forEach(triggerLoad);
    }
  }

  /* ---------- 9. LIVE VIEWERS — compteur dynamique social proof ---------- */
  function initLiveViewers() {
    document.querySelectorAll('[data-live-viewers]').forEach(function (el) {
      if (el.dataset.viewersInit) return;
      el.dataset.viewersInit = '1';

      var min = parseInt(el.dataset.min || '8', 10);
      var max = parseInt(el.dataset.max || '32', 10);
      var tickMs = parseInt(el.dataset.tickInterval || '12000', 10);
      var countEl = el.querySelector('.jpro-bb-viewers__count');
      if (!countEl) return;

      // Persist en sessionStorage : refresh = même valeur (pas de reset suspect)
      var storageKey = 'jproViewers_' + location.pathname;
      var current = parseInt(sessionStorage.getItem(storageKey) || '0', 10);
      if (!current || current < min || current > max) {
        current = Math.floor(min + Math.random() * (max - min + 1));
        sessionStorage.setItem(storageKey, String(current));
      }
      countEl.textContent = current;

      // Random walk biaisé vers la moyenne (reste crédible, pas de dérive)
      var middle = (min + max) / 2;
      setInterval(function () {
        var delta;
        if (current < middle) delta = Math.random() < 0.6 ? 1 : -1;
        else if (current > middle) delta = Math.random() < 0.6 ? -1 : 1;
        else delta = Math.random() < 0.5 ? 1 : -1;
        current = Math.max(min, Math.min(max, current + delta));
        sessionStorage.setItem(storageKey, String(current));

        // Petit fade pour rendre le changement perceptible mais discret
        countEl.style.transition = 'opacity 0.3s ease';
        countEl.style.opacity = '0.4';
        setTimeout(function () {
          countEl.textContent = current;
          countEl.style.opacity = '1';
        }, 150);
      }, tickMs);
    });
  }

  /* ---------- 10. PRODUCT GALLERY — force position 1 au load (battle Dawn auto-scroll) ---------- */
  function initProductGalleryFirstMedia() {
    var gallery = document.querySelector('media-gallery, .product__media-list, slider-component[id*="Gallery"]');
    if (!gallery) return;

    var sliderEl = document.querySelector('[id^="GalleryViewer"], .product__media-list, slider-component[id*="Gallery"]');
    var firstMedia = document.querySelector('.product__media-item:first-child, [data-media-id]:first-of-type');

    var forceFirst = function () {
      if (gallery.scrollTo) gallery.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      if (sliderEl) {
        if (sliderEl.scrollTo) sliderEl.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        sliderEl.scrollLeft = 0;
        sliderEl.scrollTop = 0;
        if (typeof sliderEl.setSlidePosition === 'function') sliderEl.setSlidePosition(0);
      }
      if (firstMedia && firstMedia.scrollIntoView) {
        firstMedia.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
      }
      // Update active thumbnail
      var thumbs = document.querySelectorAll('.thumbnail-list__item, [data-target]');
      thumbs.forEach(function (t, i) {
        var btn = t.querySelector('button, [aria-current]');
        if (i === 0) {
          t.classList.add('is-active');
          if (btn) btn.setAttribute('aria-current', 'true');
        } else {
          t.classList.remove('is-active');
          if (btn) btn.removeAttribute('aria-current');
        }
      });
    };

    // Combat Dawn : relance toutes les 80ms pendant 1.5s, après on lâche prise (user click)
    var attempts = 0;
    var ticker = setInterval(function () {
      forceFirst();
      attempts++;
      if (attempts > 18) clearInterval(ticker);
    }, 80);
  }

  /* ---------- 11. COUNTUP STATS — anime les chiffres au scroll ---------- */
  function initCountupStats() {
    // Cible les chiffres de la home (commitment) ET du hero athletic (page produit)
    var els = document.querySelectorAll('.jpro-commitment__number, .jpro-hero-athletic__stat-number');
    if (!els.length) return;

    var animate = function (el) {
      if (el.dataset.countupDone) return;
      el.dataset.countupDone = '1';

      var raw = (el.textContent || '').trim();
      var match = raw.match(/^([\d.,]+)(.*)$/);
      if (!match) return;

      var target = parseFloat(match[1].replace(',', '.'));
      var suffix = match[2]; // "K+", "★", "%", etc.
      var duration = 1800;
      var startTime = null;
      var isDecimal = /[.,]/.test(match[1]);

      var step = function (ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
        var current = target * eased;

        if (isDecimal) {
          el.textContent = current.toFixed(1).replace('.', ',') + suffix;
        } else {
          el.textContent = Math.round(current) + suffix;
        }
        if (progress < 1) requestAnimationFrame(step);
      };

      el.textContent = '0' + suffix;
      requestAnimationFrame(step);
    };

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animate(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- FOMO NOTIF (page produit only) ---------- */
  function initFomoNotif() {
    // Active uniquement sur les pages produit
    var isProduct = document.body.classList.contains('template-product') ||
                    document.querySelector('.product-form, [data-product-form]');
    if (!isProduct) return;

    // Si la notif a été fermée par l'user dans cette session, on respecte
    if (sessionStorage.getItem('jpro_fomo_dismissed') === '1') return;

    var firstNames = [
      'Lucas', 'Léa', 'Hugo', 'Emma', 'Théo', 'Jade', 'Nathan', 'Chloé',
      'Antoine', 'Manon', 'Maxime', 'Sarah', 'Mathéo', 'Camille', 'Enzo',
      'Inès', 'Tom', 'Louise', 'Adam', 'Romane', 'Raphaël', 'Alice',
      'Liam', 'Eva', 'Arthur', 'Lina', 'Gabriel', 'Mia', 'Louis', 'Zoé',
      'Paul', 'Anaïs', 'Jules', 'Margaux', 'Léo', 'Juliette', 'Noah', 'Lou',
      'Sacha', 'Charlotte', 'Ethan', 'Romy'
    ];

    var cities = [
      'Paris', 'Lyon', 'Marseille', 'Toulouse', 'Bordeaux', 'Nice', 'Nantes',
      'Lille', 'Strasbourg', 'Montpellier', 'Rennes', 'Reims', 'Saint-Étienne',
      'Le Havre', 'Toulon', 'Grenoble', 'Dijon', 'Angers', 'Brest', 'Nîmes',
      'Aix-en-Provence', 'Annecy', 'Clermont-Ferrand', 'Tours', 'Limoges',
      'Amiens', 'Perpignan', 'Metz', 'Besançon', 'Caen', 'Orléans',
      'Bruxelles', 'Genève', 'Lausanne', 'Luxembourg', 'Monaco'
    ];

    var actions = [
      "vient de commander",
      "a acheté",
      "a craqué pour",
      "s'est offert",
      "a ajouté à son panier"
    ];

    // Produit = celui de la page actuelle (récupéré dynamiquement du DOM)
    // → la notif reste toujours pertinente avec la page consultée
    var pageProductTitle = '';
    var titleEl = document.querySelector('.product__title h1, .product__title h2, h1.product__title, h2.product__title');
    if (titleEl) pageProductTitle = (titleEl.textContent || '').trim();
    // Fallback si le sélecteur change
    if (!pageProductTitle) {
      var anyH1 = document.querySelector('main h1, [class*="product"] h1');
      if (anyH1) pageProductTitle = (anyH1.textContent || '').trim();
    }
    if (!pageProductTitle) pageProductTitle = 'NyroFit Music Vision Pro — Lunettes Bluetooth';

    var products = [pageProductTitle];

    var pick = function (arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    };

    // Build le DOM une seule fois, on update le contenu à chaque show
    var notif = document.createElement('div');
    notif.className = 'jpro-fomo';
    notif.setAttribute('role', 'status');
    notif.setAttribute('aria-live', 'polite');
    document.body.appendChild(notif);

    var hideTimer = null;
    var cycleTimer = null;

    var hide = function () {
      notif.classList.remove('jpro-fomo--visible');
      clearTimeout(hideTimer);
    };

    // Image FOMO = image du produit de la page courante (dynamique) → matche toujours la fiche affichée. Fallback image fixe.
    var pageProductImage = '';
    var fomoOg = document.querySelector('meta[property="og:image"]');
    if (fomoOg && fomoOg.content) pageProductImage = fomoOg.content.replace(/^http:\/\//, 'https://');
    if (!pageProductImage) {
      var fomoImg = document.querySelector('.product__media img, .product-media-container img, media-gallery img');
      if (fomoImg) pageProductImage = fomoImg.currentSrc || fomoImg.src;
    }
    if (!pageProductImage) pageProductImage = 'https://i.postimg.cc/wxFg3gp0/014-imgi-9-picture-4.jpg';

    var show = function () {
      var name = pick(firstNames);
      var city = pick(cities);
      var action = pick(actions);
      var product = pick(products);
      var minsAgo = 1 + Math.floor(Math.random() * 14); // 1-14 min ago

      // Icone : image produit si dispo, sinon checkmark fallback
      var iconHTML = pageProductImage
        ? '<div class="jpro-fomo__icon jpro-fomo__icon--img"><img src="' + pageProductImage + '" alt="" loading="lazy"></div>'
        : '<div class="jpro-fomo__icon">✓</div>';

      notif.innerHTML =
        '<button class="jpro-fomo__close" aria-label="Fermer">×</button>' +
        iconHTML +
        '<div class="jpro-fomo__body">' +
          '<p class="jpro-fomo__txt"><strong>' + name + '</strong> de ' + city + ' ' + action + '</p>' +
          '<p class="jpro-fomo__product">' + product + '</p>' +
          '<p class="jpro-fomo__meta">Il y a ' + minsAgo + ' min<span class="jpro-fomo__verified">✓ Vérifié</span></p>' +
        '</div>';

      notif.classList.add('jpro-fomo--visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 6500);
    };

    // Click sur le bouton close → dismiss pour la session
    notif.addEventListener('click', function (e) {
      if (e.target.closest('.jpro-fomo__close')) {
        hide();
        sessionStorage.setItem('jpro_fomo_dismissed', '1');
        clearInterval(cycleTimer);
      }
    });

    // Première notif après 8s, puis cycle toutes les 25-45s (random)
    var scheduleNext = function () {
      var delay = 25000 + Math.random() * 20000;
      cycleTimer = setTimeout(function () {
        show();
        scheduleNext();
      }, delay);
    };

    setTimeout(function () {
      show();
      scheduleNext();
    }, 8000);
  }

  /* ---------- PRESS LOGOS — retry-based + MutationObserver pour résilience max ---------- */
  function initPressLogos() {
    var defaultLogos = ['VOGUE', 'COSMOPOLITAN', 'ELLE', 'VOGUE', 'COSMOPOLITAN', 'ELLE'];
    var imageMap = {
      'COSMOPOLITAN': 'https://i.postimg.cc/7PQjVBXc/017-cosmopolitan.png',
      'ELLE': 'https://i.postimg.cc/nLkPQTC0/018-elle.png'
    };

    var processTrack = function (track) {
      if (!track) return false;
      var existing = track.querySelectorAll('.jpro-press__logo');
      // Inject seulement si moins de 6 logos OU si on a un flag "non traité"
      if (existing.length < 6 || !track.dataset.jproInjected) {
        track.innerHTML = '';
        var fullList = defaultLogos.concat(defaultLogos); // 12 total
        fullList.forEach(function (name) {
          var logo = document.createElement('div');
          logo.className = 'jpro-press__logo';
          var key = name.toUpperCase();
          if (imageMap[key]) {
            var img = document.createElement('img');
            img.src = imageMap[key];
            img.alt = name;
            img.loading = 'lazy';
            img.decoding = 'async';
            logo.appendChild(img);
            logo.classList.add('jpro-press__logo--img');
          } else if (key === 'VOGUE') {
            logo.textContent = name;
            logo.classList.add('jpro-press__logo--vogue');
          } else {
            logo.textContent = name;
          }
          track.appendChild(logo);
        });
        track.dataset.jproInjected = '1';
        // Force animation restart
        track.style.animation = 'none';
        void track.offsetWidth;
        track.style.animation = 'jproMarquee 20s linear infinite';
        return true;
      }
      return false;
    };

    // Tentative immédiate
    var tryAll = function () {
      var tracks = document.querySelectorAll('.jpro-press__track');
      var did = 0;
      tracks.forEach(function (t) { if (processTrack(t)) did++; });
      return did;
    };

    tryAll();

    // Retry pendant 5s pour battre les race conditions
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var tracks = document.querySelectorAll('.jpro-press__track');
      var allDone = true;
      tracks.forEach(function (t) {
        if (!t.dataset.jproInjected) { processTrack(t); allDone = false; }
      });
      if (allDone || tries >= 10) clearInterval(poll);
    }, 500);

    // MutationObserver — si une section press est injectée plus tard (Shopify section reload),
    // on re-traite automatiquement
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('jpro-press__track')) {
                processTrack(node);
              } else if (node.querySelector) {
                var t = node.querySelector('.jpro-press__track');
                if (t) processTrack(t);
              }
            }
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---------- SHIPPING ETA — geoloc IP + dates dynamiques sous l'ATC ---------- */
  function initShippingEta() {
    // Active uniquement sur page produit
    if (!document.querySelector('.product-form, product-form, [data-product-form]')) return;

    // Cherche l'ATC button — on injecte la box après lui
    var atcContainer = document.querySelector('.product-form');
    if (!atcContainer) return;

    // Évite double injection
    if (atcContainer.parentNode.querySelector('.jpro-shipping-eta')) return;

    // Crée la box ETA
    var box = document.createElement('div');
    box.className = 'jpro-shipping-eta';
    box.innerHTML =
      '<div class="jpro-shipping-eta__row">' +
        '<span class="jpro-shipping-eta__icon">🚚</span>' +
        '<span class="jpro-shipping-eta__label">Livraison vers <strong class="jpro-shipping-eta__city">...</strong></span>' +
      '</div>' +
      '<div class="jpro-shipping-eta__row">' +
        '<span class="jpro-shipping-eta__icon">📦</span>' +
        '<span class="jpro-shipping-eta__label">Livraison estimée : <strong class="jpro-shipping-eta__dates">...</strong></span>' +
      '</div>';

    // Inject après l'ATC
    atcContainer.parentNode.insertBefore(box, atcContainer.nextSibling);

    // Calcul dates dynamiques (J+5 à J+10 jours ouvrés)
    var now = new Date();
    var addBusinessDays = function (date, days) {
      var d = new Date(date);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        // Skip weekends
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return d;
    };
    var dateMin = addBusinessDays(now, 4); // +4 jours ouvrés
    var dateMax = addBusinessDays(now, 7); // +7 jours ouvrés
    var fmt = function (d) {
      var months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
      return d.getDate() + ' ' + months[d.getMonth()];
    };
    box.querySelector('.jpro-shipping-eta__dates').textContent = fmt(dateMin) + ' – ' + fmt(dateMax);

    // Géoloc IP-based (no permission prompt, free tier)
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var city = data.city || data.country_name || 'ta région';
        var country = data.country_name || '';
        var label = city + (country && country !== city ? ', ' + country : '');
        box.querySelector('.jpro-shipping-eta__city').textContent = label;
      })
      .catch(function () {
        // Fallback si géoloc API down
        box.querySelector('.jpro-shipping-eta__city').textContent = 'ta région';
      });
  }

  /* ---------- HIDE Shop Pay (retry-based pour battre les race conditions) ---------- */
  function initHideShopPay() {
    var attempt = function () {
      var svgs = document.querySelectorAll('.jpro-bb-payments__svg');
      var hidden = 0;
      svgs.forEach(function (svgWrap) {
        var titleEl = svgWrap.querySelector('title');
        if (titleEl && /shop\s*pay/i.test(titleEl.textContent || '')) {
          svgWrap.style.display = 'none';
          hidden++;
        }
      });
      return hidden > 0;
    };

    // Tente immédiatement puis retry toutes 500ms pendant 5s
    if (!attempt()) {
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (attempt() || tries >= 10) clearInterval(poll);
      }, 500);
    }
  }

  /* ---------- PRODUCT PAGE REORDER + POLISH ---------- */
  function initProductPageReorder() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;

    // Helpers de sélection robuste (par class principale du bloc rendu)
    var find = function (sel) {
      return container.querySelector(sel);
    };

    // Récupère tous les blocs identifiés
    var topText = find('p.product__text'); // "🔥 ÉDITION LIMITÉE — SEULEMENT 200 PIÈCES"
    var title = find('.product__title');
    var stock = find('.jpro-bb-stock');
    var bundle = find('.jpro-bb-bundle');
    var colors = find('variant-selects');
    var timer = find('.jpro-bb-timer');
    var atc = container.querySelector('.product-form, product-form');
    var trust = find('.jpro-trust-row');
    var payments = find('.jpro-bb-payments');

    // 1. Stock progress → AVANT le titre, remplace visuellement la "🔥 ÉDITION LIMITÉE"
    if (stock && title) {
      stock.classList.add('jpro-bb-stock--minimal'); // style subtle (CSS gère)
      container.insertBefore(stock, title);
    }
    // 2. Masque le "🔥 ÉDITION LIMITÉE — SEULEMENT 200 PIÈCES" (doublon avec stock badge)
    if (topText) topText.style.display = 'none';

    // 3. Timer → AVANT le bundle
    if (timer && bundle) {
      container.insertBefore(timer, bundle);
    }

    // 4. ATC → après les colors (bundle puis colors puis ATC visible/accessible)
    //    On laisse Price/Savings/Qty entre colors et ATC car ils servent à la décision
    //    On remonte juste l'ATC + Payments + Trust dans le bon ordre
    if (atc && colors) {
      // Trouve le dernier élément utile avant ATC (paylater ou stock)
      var afterColors = colors.nextElementSibling;
      // On laisse Prix + Savings + Qty + Paylater en place. ATC reste là où il est dans le flow naturel.
      // Mais on s'assure que Payments puis Trust soient APRÈS ATC dans cet ordre exact.
    }

    // 5. Réorganise : ATC → Payments → Trust (avec safety check parent + try/catch)
    try {
      if (atc && payments && trust && container.contains(atc) && container.contains(payments) && container.contains(trust)) {
        if (atc.nextSibling !== payments) {
          container.insertBefore(payments, atc.nextSibling);
        }
        if (payments.nextSibling !== trust) {
          container.insertBefore(trust, payments.nextSibling);
        }
      }
    } catch (err) {
      // Si DOM a changé entre temps, on log mais on continue
      console.log('[jpro] reorder skip:', err.message);
    }

    container.classList.add('jpro-pp-reordered');
  }

  /* ---------- FORMAT EURO FR — strip 'EUR' + déplace € à droite du chiffre ----------
     Convention France : "59,99 €" (espace insécable + € après), pas "€59,99 EUR" */
  function initStripCurrencyCode() {
    var processed = new WeakSet();
    var run = function () {
      // Cible large : tout élément contenant un prix
      var priceContainers = document.querySelectorAll(
        '.product__price, .price, [class*="price__"], .price__container, ' +
        '.jpro-bb-price, .jpro-bb-bundle__price, .cart-item__price, .totals, ' +
        '[class*="money"], .product-price, .price-item, .price__regular, ' +
        '.price__sale, .price__container, .totals__total-value, ' +
        '.jpro-bb-bundle__price-now, .jpro-bb-bundle__price-was, ' +
        '.cart-drawer__price, [data-price]'
      );
      priceContainers.forEach(function (root) {
        if (processed.has(root)) return;
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
        var n;
        var nodes = [];
        while ((n = walker.nextNode())) nodes.push(n);
        var changed = false;
        nodes.forEach(function (node) {
          var v = node.nodeValue;
          if (!v) return;
          var original = v;
          // 1. Strip " EUR" (code monnaie redondant)
          v = v.replace(/\s*EUR\b/g, '');
          // 2. Déplace € de devant à derrière : "€59,99" → "59,99 €"
          //    Match € puis nombre français (digits, virgule, point, espace)
          v = v.replace(/€\s*(\d[\d\s.,]*\d|\d)/g, '$1 €');
          // 3. Normalise les espaces
          v = v.replace(/\s+/g, ' ').trim();
          if (v !== original) {
            node.nodeValue = v;
            changed = true;
          }
        });
        if (changed) processed.add(root);
      });
    };

    // Run immédiatement + retry pour les prix injectés dynamiquement (cart drawer, variant change)
    run();
    setTimeout(run, 400);
    setTimeout(run, 1200);

    // Observer les changements DOM (variant change, cart update)
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        // Throttle via timeout
        clearTimeout(window.__jproPriceTimer);
        window.__jproPriceTimer = setTimeout(run, 200);
      });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------- CHATBOT ASSISTANT NYRA — home page only ---------- */
  function initChatbot() {
    // Active UNIQUEMENT sur la home page (templates index)
    var isHome = document.body.classList.contains('template-index') ||
                 window.location.pathname === '/' ||
                 window.location.pathname === '' ||
                 window.location.pathname === '/fr' ||
                 window.location.pathname === '/fr/';
    if (!isHome) return;

    if (document.querySelector('.jpro-chatbot')) return; // évite double init

    // ============================================================
    // CATALOGUE CHATBOT — dynamique
    // Les DONNÉES (nom/prix/image/lien/dispo) viennent de Shopify via window.NF_CATALOG
    // (rendu par snippets/nf-chatbot-catalog.liquid) → toujours à jour, brouillons exclus,
    // nouveaux produits ajoutés tout seuls. On ne maintient ici QUE l'éditorial :
    // l'accroche (blurb) + le rayon (cats) de chaque produit que l'on veut mettre en avant.
    // Un produit publié SANS entrée éditoriale reste cherchable + listé dans "tout le catalogue".
    // Une entrée éditoriale dont le produit n'est pas publié est ignorée (ex. Lumen en brouillon),
    // et se réactive automatiquement le jour où tu publies le produit.
    // ============================================================
    var EDITORIAL = {
      'nyrofit-triggerarc-outil-de-pression-trigger-point': { key: 'trigger',         blurb: "Relâche nuque & trapèzes par pression ciblée",   cats: ['recovery'] },
      'nyrofit-chevillere-de-maintien':                      { key: 'chevillere',      blurb: "Maintien & récupération de la cheville",          cats: ['recovery'] },
      'nyrofit-proteges-tibias':                             { key: 'tibias',          blurb: "Protection légère, plusieurs coloris",            cats: ['recovery'] },
      'nyrofit-manchons-de-compression-genou-jambe':        { key: 'manchons',        blurb: "Compression genou & jambe, récup' accélérée",     cats: ['recovery'] },
      'nyrofit-tshirt':                                      { key: 'tshirt',          blurb: "Fais monter la chaleur, transpire +3×",           cats: ['textile'] },
      'short-running-2en1':                                  { key: 'short',           blurb: "Liberté + maintien, poche intégrée",              cats: ['textile'] },
      'nyrofit-chaussettes-anti-derapantes':                { key: 'chaussettes',     blurb: "Grip maximal, zéro glissement",                   cats: ['textile'] },
      'nyrofit-short-sculptant-push-up':                    { key: 'short_sculptant', blurb: "Taille haute gainante, effet push-up",            cats: ['femme'] },
      'nyrofit-legging-3d-sculptant':                       { key: 'legging',         blurb: "Push-up sculptant, anti-cellulite",               cats: ['femme'] },
      'lunettes-nyrovision':                                { key: 'nyrovision',      blurb: "Lunettes running haute performance",              cats: ['tech'] },
      'nyrofit-sound-vision-lunettes-bluetooth':            { key: 'lunettes',        blurb: "Audio Bluetooth intégré, sans écouteurs",         cats: ['tech'] },
      'nyrofit-lumen':                                      { key: 'lumen',           blurb: "Lumière directionnelle, ta définition ressort caméra", cats: ['tech'] }
    };

    // Construit PRODUCTS (clé → {name,price,handle,img,blurb,url}) + CAT (rayon → [clés])
    var PRODUCTS = {};
    var CAT = { recovery: [], textile: [], femme: [], tech: [], all: [] };
    (function buildCatalog() {
      var live = window.NF_CATALOG || {};
      // 1) Produits curés d'abord (ordre & accroche maîtrisés), seulement s'ils sont publiés
      for (var h in EDITORIAL) {
        if (!EDITORIAL.hasOwnProperty(h)) continue;
        var ed = EDITORIAL[h], L = live[h];
        if (!L) continue; // produit non publié → on saute
        PRODUCTS[ed.key] = { name: L.name, price: L.price, handle: h, img: L.img || '', blurb: ed.blurb, url: L.url };
        ed.cats.forEach(function (c) { if (CAT[c]) CAT[c].push(ed.key); });
        CAT.all.push(ed.key);
      }
      // 2) Produits publiés non curés → ajoutés en clé=handle, accroche vide, dans "tout le catalogue"
      for (var hh in live) {
        if (!live.hasOwnProperty(hh) || EDITORIAL[hh]) continue;
        var k = 'p_' + hh;
        PRODUCTS[k] = { name: live[hh].name, price: live[hh].price, handle: hh, img: live[hh].img || '', blurb: '', url: live[hh].url };
        CAT.all.push(k);
      }
      // Fallback : si NF_CATALOG absent (vieux cache), au moins ne pas planter
      if (!CAT.all.length) {
        PRODUCTS.contact = { name: 'Voir la boutique', price: '', handle: '', img: '', blurb: 'Tout notre catalogue', url: '/collections/all' };
      }
    })();

    // Moteur d'intention pour la saisie libre — score par mots-clés (accents ignorés)
    var INTENTS = [
      { key: 'shipping',  kw: ['livraison','livrer','delai','expedi','colis','suivi','tracking','recevoir','quand','combien de temps','transporteur'] },
      { key: 'returns',   kw: ['retour','rembours','renvoyer','echange','satisfait','garantie','30 jours'] },
      { key: 'payment',   kw: ['paiement','payer','carte','cb','paypal','klarna','3x','3 fois','apple pay','google pay','securis'] },
      { key: 'find',      kw: ['conseil','recommand','quel produit','aide','pour moi','choisir','je cherche','besoin','objectif','que prendre'] },
      { key: 'recovery',  kw: ['recup','douleur','tension','mal','nuque','dos','trapeze','cheville','tibia','massage','trigger','soulager','articulation','blessure','manchon','compression','genou','jambe','mollet'] },
      { key: 'textile',   kw: ['t-shirt','tshirt','tee','short','vetement','chaussette','transpir','sudation','sauna','maigrir','perdre du poids','sweat'] },
      { key: 'femme',     kw: ['femme','legging','sculptant','gainant','push-up','push up','taille haute','fessier','fesses','silhouette','cellulite','galbe','ventre plat'] },
      { key: 'goal_tech', kw: ['lunette','musique','audio','bluetooth','son','ecouteur','casque','running','soleil','uv','solaire','lampe','lumiere','eclairage','filmer','video','camera','lumen'] },
      { key: 'human',     kw: ['humain','conseiller','parler','quelqu','telephone','contact','email','mail','probleme','reclamation'] }
    ];

    // Arbre de conversation — nœud = { label, msg, products[], replies[] }
    var TREE = {
      welcome: {
        msg: "Hey ! Moi c'est <strong>Nyra</strong> 👋 ton assistante NyroFit.<br>Dis-moi ce que tu cherches (tu peux <strong>écrire</strong> en bas) ou choisis un sujet 👇",
        replies: ['find', 'recovery', 'textile', 'femme', 'catalog_all', 'shipping', 'returns', 'payment', 'human']
      },

      // ----- Recommandeur de produit guidé -----
      find: {
        label: '🎯 Trouve mon produit',
        msg: "Easy 😎 C'est quoi ton <strong>objectif n°1</strong> ?",
        replies: ['goal_recover', 'goal_sweat', 'goal_perform', 'goal_femme', 'goal_tech', 'catalog_all']
      },
      goal_recover: { label: '💆 Récupérer / soulager une tension', msg: "Pour relâcher tensions, douleurs et articulations, voici mes recos 👇", cat: 'recovery', replies: ['find', 'menu'] },
      goal_sweat:   { label: '🔥 Transpirer / mincir',              msg: "Pour faire grimper la chaleur et transpirer jusqu'à 3× plus 👇", products: ['tshirt'], replies: ['find', 'menu'] },
      goal_perform: { label: '🏃 Performer à l\'entraînement',      msg: "Pour bouger libre et garder le grip à chaque appui 👇", products: ['short', 'chaussettes'], replies: ['find', 'menu'] },
      goal_femme:   { label: '🍑 Sculpter ma silhouette',          msg: "Nos pièces femme taille haute, effet gainant & push-up 👇", cat: 'femme', replies: ['find', 'sizing', 'menu'] },
      goal_tech:    { label: '🎧 Lunettes & tech',                 msg: "Audio sans écouteurs, lunettes running et accessoires tech 👇", cat: 'tech', replies: ['find', 'menu'] },

      // ----- Catégories produits (rayons dynamiques tirés du catalogue live) -----
      recovery: {
        label: '💆 Récupération & maintien',
        msg: "Notre gamme récup' cible tensions, articulations et muscles 👇",
        cat: 'recovery',
        replies: ['shipping', 'menu']
      },
      textile: {
        label: '👕 Textile & training',
        msg: "Le textile NyroFit, pensé performance et transpiration 👇",
        cat: 'textile',
        replies: ['sizing', 'menu']
      },
      femme: {
        label: '🍑 Collection Femme',
        msg: "Taille haute, effet gainant, push-up : pensé pour sculpter ta silhouette 👇",
        cat: 'femme',
        replies: ['sizing', 'menu']
      },
      catalog_all: {
        label: '🛍️ Tout le catalogue',
        msg: "Voici l'ensemble de nos produits disponibles 👇",
        cat: 'all',
        replies: ['find', 'menu']
      },

      // ----- FAQ -----
      shipping: {
        label: '🚚 Livraison & délais',
        msg: "Livraison <strong>OFFERTE</strong> dès 50€ d'achat 🎁<br><br>📦 Expédition sous <strong>24-48h</strong> ouvrées<br>🇫🇷 France : <strong>3-5 jours</strong><br>🇪🇺 Europe : 5-8 jours<br><br>Tu reçois un email avec ton n° de suivi dès l'expédition.",
        replies: ['shipping_track', 'shipping_delay', 'menu']
      },
      shipping_track: {
        label: '📍 Suivre ma commande',
        msg: "Va sur <a href='/pages/suivi-de-commande' target='_blank'>la page de suivi</a> avec ton numéro de commande (reçu par email) 📦",
        replies: ['shipping', 'menu']
      },
      shipping_delay: {
        label: '⏱️ Ma commande est en retard',
        msg: "Désolée pour le délai ⏱️<br><br>Vérifie d'abord le suivi via le lien dans ton email. Si plus de 7 jours sans update, contacte-nous : <a href='mailto:contact@nyrofit.com'>contact@nyrofit.com</a>",
        replies: ['shipping', 'menu']
      },
      returns: {
        label: '↩️ Retour & remboursement',
        msg: "<strong>30 jours</strong> pour changer d'avis, satisfait ou remboursé ✓<br><br>📩 Demande via <a href='/pages/contact' target='_blank'>le formulaire contact</a><br>📦 Retour gratuit en France<br>💰 Remboursement sous 5 jours après réception",
        replies: ['returns_how', 'menu']
      },
      returns_how: {
        label: '📋 Comment retourner ?',
        msg: "1️⃣ Envoie un email à <strong>contact@nyrofit.com</strong> avec ton n° de commande<br>2️⃣ On t'envoie une étiquette retour prépayée<br>3️⃣ Dépose le colis en point relais<br>4️⃣ Remboursement sous 5 jours",
        replies: ['returns', 'menu']
      },
      sizing: {
        label: '📏 Quelle taille choisir ?',
        msg: "Chaque fiche produit a son <strong>guide des tailles</strong> détaillé 📏<br><br>✓ Le textile (t-shirt, short) taille normalement → prends ta taille habituelle<br>✓ Les chaussettes sont en taille unique ajustable<br>✓ Protège-tibias & chevillère : tableau de mesures sur la fiche<br><br>Un doute ? Écris-moi le produit, je t'aiguille 👇",
        replies: ['textile', 'human', 'menu']
      },
      payment: {
        label: '💳 Moyens de paiement',
        msg: "On accepte :<br>💳 <strong>CB, Visa, Mastercard, Amex</strong><br>🍎 <strong>Apple Pay</strong> & 🟢 <strong>Google Pay</strong><br>💰 <strong>PayPal</strong><br>💳 <strong>Klarna</strong> — paie en 3× sans frais<br><br>Transactions 100% sécurisées 🔒",
        replies: ['menu']
      },
      human: {
        label: '🧑‍💻 Parler à un humain',
        msg: "Pour une question personnalisée, l'équipe (FR 🇫🇷, lun-ven) te répond vite :<br><br>📧 <strong>contact@nyrofit.com</strong> (sous 24h)<br>📱 Instagram <a href='https://instagram.com/nyrofit.shop' target='_blank'>@nyrofit.shop</a>",
        replies: ['menu']
      },
      menu: {
        label: '↩️ Retour au menu',
        msg: "Que veux-tu savoir d'autre ?",
        replies: ['find', 'recovery', 'textile', 'shipping', 'returns', 'payment', 'human']
      }
    };

    // Build le widget une fois
    var widget = document.createElement('div');
    widget.className = 'jpro-chatbot';
    widget.innerHTML =
      '<button class="jpro-chatbot__toggle" type="button" aria-label="Ouvrir le chat">' +
        '<span class="jpro-chatbot__toggle-icon">💬</span>' +
        '<span class="jpro-chatbot__badge">1</span>' +
      '</button>' +
      '<div class="jpro-chatbot__panel" hidden>' +
        '<div class="jpro-chatbot__header">' +
          '<div class="jpro-chatbot__avatar">N</div>' +
          '<div class="jpro-chatbot__header-info">' +
            '<p class="jpro-chatbot__name">Nyra</p>' +
            '<p class="jpro-chatbot__status"><span class="jpro-chatbot__dot"></span>En ligne · répond en quelques secondes</p>' +
          '</div>' +
          '<button class="jpro-chatbot__close" type="button" aria-label="Fermer">×</button>' +
        '</div>' +
        '<div class="jpro-chatbot__messages"></div>' +
        '<form class="jpro-chatbot__inputbar">' +
          '<input class="jpro-chatbot__input" type="text" placeholder="Écris ta question…" autocomplete="off" maxlength="200">' +
          '<button class="jpro-chatbot__send" type="submit" aria-label="Envoyer">➤</button>' +
        '</form>' +
        '<div class="jpro-chatbot__footer">Propulsé par NyroFit AI</div>' +
      '</div>';
    document.body.appendChild(widget);

    // Refs DOM
    var panel = widget.querySelector('.jpro-chatbot__panel');
    var messagesEl = widget.querySelector('.jpro-chatbot__messages');
    var toggleBtn = widget.querySelector('.jpro-chatbot__toggle');
    var closeBtn = widget.querySelector('.jpro-chatbot__close');
    var badge = widget.querySelector('.jpro-chatbot__badge');
    var toggleIcon = widget.querySelector('.jpro-chatbot__toggle-icon');
    var inputForm = widget.querySelector('.jpro-chatbot__inputbar');
    var inputEl = widget.querySelector('.jpro-chatbot__input');

    var isOpen = false;
    var welcomeShown = false;

    // Helpers
    function scrollToBottom() {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }
    function addMessage(type, html) {
      var wrap = document.createElement('div');
      wrap.className = 'jpro-chatbot__msg jpro-chatbot__msg--' + type;
      wrap.innerHTML = '<div class="jpro-chatbot__bubble">' + html + '</div>';
      messagesEl.appendChild(wrap);
      scrollToBottom();
    }
    function showTyping() {
      var t = document.createElement('div');
      t.className = 'jpro-chatbot__typing';
      t.innerHTML = '<span></span><span></span><span></span>';
      messagesEl.appendChild(t);
      scrollToBottom();
    }
    function hideTyping() {
      var t = messagesEl.querySelector('.jpro-chatbot__typing');
      if (t) t.remove();
    }
    function disableOldButtons() {
      messagesEl.querySelectorAll('.jpro-chatbot__reply').forEach(function (b) {
        b.disabled = true;
        b.classList.add('jpro-chatbot__reply--disabled');
      });
    }
    function renderReplies(keys) {
      var div = document.createElement('div');
      div.className = 'jpro-chatbot__replies';
      keys.forEach(function (key) {
        var node = TREE[key];
        if (!node) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jpro-chatbot__reply';
        btn.textContent = node.label || key;
        btn.dataset.key = key;
        btn.addEventListener('click', function () {
          goTo(key);
        });
        div.appendChild(btn);
      });
      messagesEl.appendChild(div);
      scrollToBottom();
    }

    // Rendu des cartes produit (image + nom + prix + lien)
    function renderProducts(keys) {
      keys.forEach(function (k) {
        var p = PRODUCTS[k];
        if (!p) return;
        var card = document.createElement('a');
        card.className = 'jpro-chatbot__product';
        card.href = p.url || (p.handle ? '/products/' + p.handle : '/collections/all');
        card.target = '_blank';
        card.rel = 'noopener';
        var imgHtml = p.img
          ? '<img class="jpro-chatbot__product-img" src="' + p.img + '" alt="" loading="lazy">'
          : '<span class="jpro-chatbot__product-img jpro-chatbot__product-img--ph">N</span>';
        card.innerHTML = imgHtml +
          '<span class="jpro-chatbot__product-info">' +
            '<span class="jpro-chatbot__product-name">' + p.name + '</span>' +
            '<span class="jpro-chatbot__product-blurb">' + p.blurb + '</span>' +
            '<span class="jpro-chatbot__product-price">' + p.price + '</span>' +
          '</span>' +
          '<span class="jpro-chatbot__product-cta">Voir →</span>';
        messagesEl.appendChild(card);
      });
      scrollToBottom();
    }

    // Normalisation texte (minuscules + sans accents) pour le matching
    function normalize(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }
    // Moteur d'intention — score par mots-clés, renvoie la meilleure clé ou null
    function matchIntent(text) {
      var t = normalize(text);
      // Détection directe d'un produit nommé
      for (var pk in PRODUCTS) {
        if (PRODUCTS.hasOwnProperty(pk) && t.indexOf(normalize(PRODUCTS[pk].name.split(' ')[0])) !== -1 && PRODUCTS[pk].name.length > 4) {
          // (ex. "trigger", "lumen", "short"...) — géré aussi par INTENTS, donc on continue le scoring
        }
      }
      var best = null, bestScore = 0;
      INTENTS.forEach(function (intent) {
        var score = 0;
        intent.kw.forEach(function (kw) { if (t.indexOf(kw) !== -1) score++; });
        if (score > bestScore) { bestScore = score; best = intent.key; }
      });
      return bestScore > 0 ? best : null;
    }

    // Affiche la réponse d'un nœud (sans re-poster le label en message user)
    function sendNode(key) {
      var node = TREE[key];
      if (!node) return;
      showTyping();
      setTimeout(function () {
        hideTyping();
        addMessage('bot', node.msg);
        // node.cat = rayon dynamique (tiré du catalogue live) ; node.products = liste fixe de clés
        if (node.cat && CAT[node.cat] && CAT[node.cat].length) renderProducts(CAT[node.cat]);
        else if (node.products && node.products.length) renderProducts(node.products);
        if (node.replies && node.replies.length) renderReplies(node.replies);
      }, 600 + Math.random() * 600);
    }

    // CORE — clic sur un bouton (poste le choix puis répond)
    function goTo(key) {
      var node = TREE[key];
      if (!node) return;
      disableOldButtons();
      addMessage('user', node.label || key);
      sendNode(key);
    }

    // Saisie libre — comprend l'intention puis répond
    function handleText(text) {
      text = (text || '').trim();
      if (!text) return;
      addMessage('user', text);
      disableOldButtons();
      var key = matchIntent(text);
      if (key) {
        sendNode(key);
      } else {
        showTyping();
        setTimeout(function () {
          hideTyping();
          addMessage('bot', "Hmm, je n'ai pas tout saisi 🤔<br>Choisis un sujet ci-dessous, ou écris-nous : <strong>contact@nyrofit.com</strong>");
          renderReplies(['find', 'shipping', 'returns', 'payment', 'human']);
        }, 600 + Math.random() * 500);
      }
    }

    // Open/Close — utilise la classe --open ET hidden attribute (double sécurité)
    function openPanel() {
      panel.hidden = false;
      panel.classList.add('jpro-chatbot__panel--open');
      isOpen = true;
      badge.style.display = 'none';
      toggleIcon.textContent = '×';
      toggleBtn.classList.remove('jpro-chatbot__toggle--bounce');
      try { localStorage.setItem('nyra_opened', '1'); } catch (e) {}
      /* Pas de focus auto sur l'input : évite l'ouverture du clavier au moment où le panel s'ouvre (surtout mobile). L'utilisateur tape sur le champ quand il veut écrire. */
      if (!welcomeShown) {
        showTyping();
        setTimeout(function () {
          hideTyping();
          addMessage('bot', TREE.welcome.msg);
          renderReplies(TREE.welcome.replies);
          welcomeShown = true;
        }, 800);
      }
    }
    function closePanel() {
      panel.hidden = true;
      panel.classList.remove('jpro-chatbot__panel--open');
      isOpen = false;
      toggleIcon.textContent = '💬';
    }

    // Event listeners — clairs et uniques
    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isOpen) closePanel(); else openPanel();
    });
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closePanel();
    });

    // Saisie libre — submit du formulaire
    inputForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = inputEl.value;
      inputEl.value = '';
      handleText(val);
    });

    // Persistance : si déjà ouvert lors d'une visite passée, pas de bounce ni badge
    var seen = false;
    try { seen = localStorage.getItem('nyra_opened') === '1'; } catch (e) {}
    if (seen) { badge.style.display = 'none'; }

    // Bounce attractif après 5s + 30s si jamais ouvert (et pas déjà vu)
    if (!seen) {
      setTimeout(function () {
        if (!isOpen) toggleBtn.classList.add('jpro-chatbot__toggle--bounce');
      }, 5000);
      setTimeout(function () {
        if (!isOpen) toggleBtn.classList.add('jpro-chatbot__toggle--bounce');
      }, 30000);
    }
  }

  /* ---------- SCROLL TO REVIEWS — event delegation (couvre tout, même DOM dynamique) ---------- */
  function initReviewsScroll() {
    // Une seule fois - listener global au body
    if (document.body.dataset.jproReviewsBound === '1') return;
    document.body.dataset.jproReviewsBound = '1';

    document.addEventListener('click', function (e) {
      // Match le lien cliqué OU son parent ancestor jusqu'à 3 niveaux
      var link = e.target.closest(
        'a[href="#reviews"], a[href*="reviews"], a[href*="#avis"], ' +
        '.jpro-bb a, [class*="rating"] a, .product__title ~ .jpro-bb a'
      );
      if (!link) return;

      // Cible reviews section (fallbacks multiples)
      var target =
        document.querySelector('.jpro-reviews') ||
        document.querySelector('section.jpro-reviews') ||
        document.querySelector('[class*="shopify-section"] .jpro-reviews') ||
        document.querySelector('.jpro-bb-mini-reviews') ||
        document.getElementById('reviews') ||
        document.querySelector('section[id*="reviews"]') ||
        document.querySelector('[class*="reviews"]:not(.jpro-bb)');

      if (!target) {
        console.log('[jpro] reviews section not found');
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      // Header sticky offset
      var headerEl = document.querySelector('sticky-header, .header-wrapper, .shopify-section--header, header.header');
      var headerHeight = headerEl ? headerEl.offsetHeight : 80;

      var top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, true); // capture phase pour intercepter avant les autres handlers
  }

  /* ---------- FREE GIFT IN CART — instant render, position haute, full responsive ---------- */
  function initFreeGiftInCart() {
    var GIFT = {
      image: 'https://i.postimg.cc/MGcX014p/002-main-image-7-3.jpg',
      name: 'Lunettes Velocity Premium',
      subtitle: 'Lunettes sport · Verres polarisés',
      originalPrice: '29,99 €'
    };

    var buildGiftHTML = function () {
      var div = document.createElement('div');
      div.className = 'jpro-free-gift';
      div.innerHTML =
        '<div class="jpro-free-gift__badge">🎁 CADEAU OFFERT</div>' +
        '<div class="jpro-free-gift__content">' +
          '<div class="jpro-free-gift__image">' +
            '<img src="' + GIFT.image + '" alt="' + GIFT.name + '" loading="eager" decoding="async">' +
          '</div>' +
          '<div class="jpro-free-gift__info">' +
            '<p class="jpro-free-gift__name">' + GIFT.name + '</p>' +
            '<p class="jpro-free-gift__subtitle">' + GIFT.subtitle + '</p>' +
            '<div class="jpro-free-gift__price">' +
              '<span class="jpro-free-gift__price-was">' + GIFT.originalPrice + '</span>' +
              '<span class="jpro-free-gift__price-now">GRATUIT</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<p class="jpro-free-gift__note">✓ Inclus dans ta commande, sans action de ta part</p>';
      return div;
    };

    var render = function () {
      // Cible plusieurs containers possibles
      var drawers = document.querySelectorAll('cart-drawer, .cart-drawer, .drawer:not(.shopify-section)');
      drawers.forEach(function (drawer) {
        if (drawer.querySelector('.jpro-free-gift')) return;

        // Détection instantanée d'items via DOM (pas de fetch)
        var hasItems =
          drawer.querySelector('.cart-item, .cart-drawer__item, [data-cart-item], cart-drawer-items > *:not(:empty)');
        if (!hasItems) return;

        // INSÈRE DIRECT après le dernier cart-item — position haute
        var items = drawer.querySelectorAll('.cart-item');
        if (items.length > 0) {
          var lastItem = items[items.length - 1];
          var giftEl = buildGiftHTML();
          // Insère après le dernier item, dans le même parent (la liste)
          if (lastItem.parentNode) {
            lastItem.parentNode.insertBefore(giftEl, lastItem.nextSibling);
          }
        } else {
          // Fallback : juste après le wrapper items
          var itemsWrap = drawer.querySelector('cart-drawer-items, .cart-items, .drawer__cart-items-wrapper');
          if (itemsWrap) {
            var giftEl2 = buildGiftHTML();
            itemsWrap.appendChild(giftEl2);
          }
        }
      });
    };

    // Renderings : init + events cart + observer DOM
    render();

    // Écoute les events Dawn natifs (mise à jour panier)
    ['cart:update', 'cart-drawer:open', 'cart:add', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(render, 50); });
    });

    // Observer DOM léger : seulement sur le body, déclenche dès qu'un cart-item est ajouté
    if (window.MutationObserver) {
      var debounce;
      var mo = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(render, 80);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---------- INIT — chaque init wrap en try/catch pour isoler les erreurs ---------- */
  function safeRun(fn, name) {
    try { fn(); } catch (e) { console.log('[jpro] ' + name + ' failed:', e.message); }
  }

  function init() {
    safeRun(initScrollFadeUp, 'initScrollFadeUp');
    safeRun(initBeforeAfterSlider, 'initBeforeAfterSlider');
    safeRun(initBundleSync, 'initBundleSync');
    safeRun(initUrgencyTimer, 'initUrgencyTimer');
    safeRun(initStickyAtc, 'initStickyAtc');
    safeRun(initCartTimer, 'initCartTimer');
    safeRun(initCartProgress, 'initCartProgress');
    safeRun(initAutoplayVideo, 'initAutoplayVideo');
    safeRun(initLiveViewers, 'initLiveViewers');
    safeRun(initProductGalleryFirstMedia, 'initProductGalleryFirstMedia');
    safeRun(initCountupStats, 'initCountupStats');
    safeRun(initProductPageReorder, 'initProductPageReorder');
    safeRun(initStripCurrencyCode, 'initStripCurrencyCode');
    safeRun(initPressLogos, 'initPressLogos');
    safeRun(initHideShopPay, 'initHideShopPay');
    safeRun(initShippingEta, 'initShippingEta');
    safeRun(initFomoNotif, 'initFomoNotif');
    safeRun(initChatbot, 'initChatbot');
    safeRun(initReviewsScroll, 'initReviewsScroll');
    // safeRun(initFreeGiftInCart, 'initFreeGiftInCart'); // DÉSACTIVÉ — ad coupée sur le produit Velocity
    // Nettoyage des éventuels blocs déjà rendus dans le DOM (au cas où l'ancien code aurait laissé un cache)
    document.querySelectorAll('.jpro-free-gift').forEach(function(el) { el.remove(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor reload (so editor preview works)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
